var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4197 9.2123L1.57224 0.239893C1.24911 -0.0799643 0.725852 -0.0799643 0.401894 0.239893C0.0795768 0.55975 0.0795768 1.08464 0.401894 1.4045L9.65561 9.83561L0.401894 18.2749C0.0795768 18.5948 0.0795768 19.1115 0.401894 19.4395C0.725852 19.7594 1.24911 19.7594 1.57224 19.4395L11.4197 10.4671C11.592 10.2949 11.6658 10.0652 11.6543 9.83561C11.6658 9.61417 11.592 9.38453 11.4197 9.2123Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightNextIcon);
export default __webpack_public_path__ + "static/media/rightNextIcon.37892c7d914f9a63cfc52c7f4b10ee20.svg";
export { ForwardRef as ReactComponent };